import { render, staticRenderFns } from "./reportarEventos.vue?vue&type=template&id=6dc5c9e6&scoped=true"
import script from "./reportarEventos.vue?vue&type=script&lang=js"
export * from "./reportarEventos.vue?vue&type=script&lang=js"
import style0 from "./reportarEventos.vue?vue&type=style&index=0&id=6dc5c9e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc5c9e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc5c9e6')) {
      api.createRecord('6dc5c9e6', component.options)
    } else {
      api.reload('6dc5c9e6', component.options)
    }
    module.hot.accept("./reportarEventos.vue?vue&type=template&id=6dc5c9e6&scoped=true", function () {
      api.rerender('6dc5c9e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/exceptionReporting/component/reportarEventos.vue"
export default component.exports